import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import {
  getLeads,
  getLead,
  exportLeads,
  resendLead,
  resetLeadStatus,
} from "../../api/leads/lead.api.js";

export const useLeadsQuery = () => {
  return useQuery({
    queryKey: ["leads"],
    queryFn: getLeads,
  });
};

export const useLeadQuery = (id) => {
  return useQuery({
    queryKey: ["leads", id],
    queryFn: () => getLead(id),
    enabled: !!id,
  });
};

export const useExportLeads = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: exportLeads,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
  });
};

export const useResendLead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resendLead,
    onSuccess: async () => {
      await new Promise((resolve) =>
        setTimeout(resolve, 1000)
      );
    
      queryClient.invalidateQueries({
        queryKey: ["leads"],
      });
    }
  });
};



export const useResetLeadStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resetLeadStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
  });
};
